export default "__VITE_ASSET__CDNUr97y__"